import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppForumPostsPage } from './app-forum-posts';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppForumPostsPage,
  ],
  imports: [
    IonicPageModule.forChild(AppForumPostsPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppForumPostsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-forum-posts/app-forum-posts.module.ts